module.exports = __webpack_public_path__ + "fonts/VetoSans-LightItalic_1.89e70781.woff";